/* Bundle prices live in Shopify automatic discounts, never in variant prices.
   PRICE TEST (Oct 2026): all mask variants are $26.95; Buy 2 takes $6.95 off
   ($46.95) and Buy 3 takes $18.90 off ($61.95). Mystery Mask alone = $26.95.
   Change the discount, not the variant.
   `was` is the honest strike-through for each tier (unit compare-at × qty). */
window.IF_BUNDLES = [
  {qty:'1 MASK',  per:'$26.95 each', price:'26.95', was:'44.95',  badge:null},
  {qty:'2 MASKS', per:'$23.48 each', price:'46.95', was:'89.90',  badge:'MOST POPULAR'},
  {qty:'3 MASKS', per:'$20.65 each', price:'61.95', was:'134.85', badge:'BEST VALUE'}
];
/* old → new, so no stale figure can survive a re-render */
window.IF_PRICE_MAP = {'26.00':'26.95','45.00':'46.95','62.00':'61.95','27.95':'26.95','48.95':'46.95','29.95':'26.95','49.95':'46.95','64.95':'61.95','39.99':'44.95'};
var IFCDN='https://cdn.shopify.com/s/files/1/0979/3604/8475/files/';
window.IF_GLOVES_IMG   = IFCDN+'if-gloves.webp?v=1790006736';
window.IF_MYSTERY_IMG  = IFCDN+'if-mystery.webp?v=1790010047';
window.IF_FREESHIP_IMG = IFCDN+'if-freeship.webp?v=1790008194';
